import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function fullNameValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';

    // Remove extra spaces and split by spaces
    const parts = value.trim().split(/\s+/);

    // Full name if has at least two words
    if (parts.length >= 2) {
      return null; // ✅ valid
    }

    return {fullName: true}; // ❌ invalid
  };
}
